export const UserAddressIcon = () => (
  <svg fill="none" height="86" viewBox="5 0 79 86" width="79" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_567_3608)">
      <path
        d="M22.8384 72.3446V14.1395H69.1202L76.5253 21.5098V84.1574H22.8384V79.7053"
        stroke="#01E47F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M35.2217 43.7414H63.8677"
        stroke="#01E47F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M35.2217 50.7845H63.8677"
        stroke="#01E47F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M35.2217 58.1982H55.6831"
        stroke="#01E47F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </g>
    <defs>
      <clipPath id="clip0_567_3608">
        <rect fill="white" height="86" transform="translate(0.623047)" width="77.7534" />
      </clipPath>
    </defs>
  </svg>
);
